import Orchestrator from "./ThreeJS/Orchestrator.js";
import { getActiveSplat } from "./ThreeJS/splats.js";

const activeSplat = getActiveSplat();

for (const link of document.querySelectorAll(".splat-nav a")) {
    const id = link.getAttribute("href")?.replace(/^#/, "");
    if (id === activeSplat.id) {
        link.classList.add("is-active");
    }
}

window.addEventListener("hashchange", () => {
    window.location.reload();
});

const creditsModal = document.querySelector("#credits-modal");
const creditsOpen = document.querySelector("#credits-open");

const openCredits = () => {
    creditsModal.hidden = false;
};

const closeCredits = () => {
    creditsModal.hidden = true;
};

creditsOpen.addEventListener("click", openCredits);

creditsModal.addEventListener("click", (event) => {
    if (event.target.closest("[data-credits-close]")) {
        closeCredits();
    }
});

window.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !creditsModal.hidden) {
        closeCredits();
    }
});

const orchestrator = new Orchestrator(document.querySelector("canvas.webgl"));
